var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Editor',{key:_vm.editorKey,attrs:{"init":_vm.editorConfig,"api-key":"cdr20ntkagi79fq97o93vhjkh1pq9lcwc33s9asghv84r2jx"},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }